var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-snackbar', {
    staticStyle: {
      "white-space": "pre"
    },
    attrs: {
      "bottom": "",
      "multi-line": "",
      "right": "",
      "auto-height": "",
      "vertical": "",
      "timeout": _vm.timeout,
      "color": _vm.color
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.title ? _c('h6', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n  " + _vm._s(_vm.message) + "\n  "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_vm.showHelp ? _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white",
      "to": "/help"
    }
  }, [_vm._v("Help")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white"
    },
    nativeOn: {
      "click": function click($event) {
        _vm.show = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }